import React from 'react';
import ArtistHomePage from './ArtistHomePage';
import ArtistSignupSuccessPage from './ArtistSignupSuccessPage';
import SetupBillingPage from './SetupBillingPage';
import LoginPage from './LoginPage';
import LogoutPage from './LogoutPage';
import SignupPage from './SignupPage';
import SignupSuccessPage from './SignupSuccessPage';
import AccountPage from './AccountPage';
import ArtworkTastePage from './ArtworkTastePage';
import HomePage from './HomePage';
import ArtworkDetailsPage from './ArtworkDetailsPage';
import PrivacyAndTermsPage from './PrivacyAndTermsPage';
import ScheduleDeliveryPage from './ScheduleDeliveryPage';
import ConfirmDeliveryPage from './ConfirmDeliveryPage';
import TastemakerPage from './TastemakerPage';
import TastemakerAdminPage from './admin/TastemakerAdminPage';
import PaymentDeclinedPage from './PaymentDeclinedPage';

const routes = [
  { path: '/', action: () => <HomePage /> },
  { path: '/privacy-and-terms', action: () => <PrivacyAndTermsPage /> },
  { path: '/account', action: () => <AccountPage /> },
  { path: '/setup-billing', action: () => <SetupBillingPage /> },
  { path: '/artists', action: () => <ArtistHomePage /> },
  { path: '/artist-signup-success', action: () => <ArtistSignupSuccessPage /> },
  { path: '/login', action: () => <LoginPage /> },
  { path: '/logout', action: () => <LogoutPage /> },
  { path: '/account', action: () => <AccountPage /> },
  { path: '/signup', action: () => <SignupPage /> },
  { path: '/signup-success', action: () => <SignupSuccessPage /> },
  { path: '/admin/tastemaker/:userId', action: (location) => <TastemakerAdminPage location={location} /> },
  { path: '/nuq-grid', action: () => <ArtworkTastePage /> },
  { path: '/art/:id', action: (location) => <ArtworkDetailsPage location={location} /> },
  { path: '/schedule-delivery', action: () => <ScheduleDeliveryPage /> },
  { path: '/confirm-delivery', action: () => <ConfirmDeliveryPage /> },
  { path: '/payment-declined', action: () => <PaymentDeclinedPage /> },
  { path: '/tastemaker', action: () => <TastemakerPage /> },
//  { path: '/artist/:id', action: () => <ArtistDetailsPage /> },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js